// extracted by mini-css-extract-plugin
export default {"maskScrollerOuter":"maskScrollerOuter-AqlWJ","maskScrollerInner":"maskScrollerInner-dCq3_"};